import API from "store/api"
import serialize from "store/serialize"
import * as types from "../types/actions/items"

export const _setItems = (items = []) => ({
  type: types.ITEMS_SET,
  items
})

export const clearItems = () => ({
  type: types.ITEMS_CLEAR
})

export const updateItem = item => ({
  type: types.ITEMS_ITEM_UPDATE,
  item
})

export const moveItems = () => ({
  type: types.ITEMS_MOVE
})

export const getItems = eventUrl => {
  return dispatch => {
    return API.get(`/items/event/${eventUrl}`)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response
      })
      .then(response => response.body)
      .then(data => {
        serialize(
          "item",
          data.map(d => {
            d = {
              ...d,
              image: JSON.parse(d.image)
            }
            return d
          })
        ).then(response => {
          dispatch(_setItems(response))
          return response
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/items.js